import { Logout } from "./logout";
import { message } from "antd"


let inactivityTimeout; 

const INACTIVITY_TIME = 1 * 60 * 1000; // 15 minutotes sin hacer nada
const TIMEOUT = 2 * 1000;


const onInactivity = () => {
  validarExpiracionToken(); 
}

const resetInactivityTimer = () => {
  clearTimeout(inactivityTimeout); 
  inactivityTimeout = setTimeout(onInactivity, INACTIVITY_TIME); 
}

const validarExpiracionToken = () => {
    const expiracion = localStorage.getItem('expTokenTime'); 
    if (!expiracion) return;
  
    const expiracionNumerica = parseInt(expiracion, 10);
    const ahora = Date.now();

    if (ahora > (expiracionNumerica * 1000)) {
      const loggingOut = message.loading("El token ha expirado.")
       loggingOut()

       setTimeout( Logout, TIMEOUT);
      
    }
  };


const iniciarValidacionToken = () => {
// validarExpiracionToken(); 
// resetInactivityTimer();

// window.addEventListener("mousemove", resetInactivityTimer);
// window.addEventListener("keydown", resetInactivityTimer);
// window.addEventListener("click", resetInactivityTimer);
// window.addEventListener("scroll", resetInactivityTimer);

};


export {iniciarValidacionToken}